import { 
  REVISION_PRICE_INFO,
  REVISION_PRICE_STEP,
  REVISION_PRICE_LOGS,
  REVISION_PRICE_RATE,
  REVISION_PRICE_ID,
  NEXT_REVISION_INFO
} from "../actionTypes";

const initialState = {
  id: null,
  rate: [],
  step: 0,
	info: {
		version: null,
		name: "",
		note: "",
	},
  nextInfo: {
    version: '',
    name: '',
    nextVersion: ''
  },
  logs: []
};

const revisionPriceInfo = (state, action) => {
	return {...state, info: action.info}
}

const revisionPriceStep = (state, action) => {
	return {...state, step: action.step}
}

const revisionPriceLogs = (state, action) => {
	return {...state, logs: action.logs}
}

const revisionPriceRate = (state, action) => {
	return {...state, rate: action.rate}
}

const revisionPriceId = (state, action) => {
	return {...state, id: action.id}
}

const nextRevisionInfo = (state, action) => {
	return {...state, nextInfo: action.nextInfo}
}

const revisionPrice = (state = initialState, action) => {
	switch (action.type) {
		case REVISION_PRICE_INFO:
			return revisionPriceInfo(state, action)
    case REVISION_PRICE_STEP:
      return revisionPriceStep(state, action)
    case REVISION_PRICE_LOGS:
      return revisionPriceLogs(state, action)
    case REVISION_PRICE_RATE:
      return revisionPriceRate(state, action)
    case REVISION_PRICE_ID:
      return revisionPriceId(state, action)
    case NEXT_REVISION_INFO:
      return nextRevisionInfo(state, action)
		default:
			return state
	}
}

export default revisionPrice


// WEBPACK FOOTER //
// ./src/store/reducers/revisionPrice.js